// extracted by mini-css-extract-plugin
module.exports = {"resizeable":"styles_resizeable__rV6bg","button":"styles_button__1oWrE"};